module.exports = __webpack_public_path__ + "static/fonts/Roboto-Medium.0b76306.otf";


//////////////////
// WEBPACK FOOTER
// ./src/views/concierge/font/roboto/Roboto-Medium.otf
// module id = 1l2I
// module chunks = 0